// src/components/StartScreen.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../css/modules/StartScreen.module.css';
import { PATENTY } from '../data/patenty';
import { wybranyPatent, zapiszPatent } from '../lib/patent';

/**
 * Wybór patentu przed rejsem.
 *
 * W bliźniaczych serwisach jest tu wybór kategorii prawa jazdy. U nas decyduje
 * patent, bo od niego zależy pula pytań: żeglarz jachtowy i sternik motorowodny
 * mają wspólne przepisy prawa drogi, ale własną teorię i manewrowanie.
 * Wybór zapisujemy lokalnie (lib/patent.js) i - dla zalogowanych - w profilu.
 */
const StartScreen = () => {
  const navigate = useNavigate();
  const [patent, setPatent] = useState(wybranyPatent);
  const [isLoading, setIsLoading] = useState(false);

  const zapiszWProfilu = async slug => {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem('access_token');
    if (!token || !API_BASE_URL) return;

    try {
      setIsLoading(true);
      await fetch(`${API_BASE_URL}/cyber/user_info`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ preferred_categories: [slug] }),
      });
    } catch (err) {
      /* zapis w profilu jest wygodą, nie warunkiem gry - wybór i tak mamy lokalnie */
    } finally {
      setIsLoading(false);
    }
  };

  const handleStart = async () => {
    zapiszPatent(patent);
    await zapiszWProfilu(patent);
    navigate('/intro');
  };

  return (
    <div className={styles.container}>
      <div className={styles.overlay}></div>
      <div className={styles.content}>
        <h1>Testy na patent żeglarski - wybierz swój egzamin</h1>
        <p className={styles.description}>
          Pytania pochodzą z baz egzaminacyjnych PZŻ i PZMWiNW. Wybierz patent, a potem zmierz się
          z żywiołem: każda dobra odpowiedź to cios w przeciwnika, każda zła - w twoją załogę.
        </p>

        <h2>Wybierz patent:</h2>
        <div className={styles.categoriesGrid}>
          {PATENTY.map(p => (
            <button
              key={p.slug}
              className={`${styles.categoryButton} ${patent === p.slug ? styles.selectedCategory : ''}`}
              onClick={() => setPatent(p.slug)}
              aria-pressed={patent === p.slug}
            >
              <span className={styles.categoryShort}>{p.krotko}</span>
              <span className={styles.categoryName}>{p.nazwa}</span>
              <span className={styles.categoryHint}>
                egzamin {p.zwiazekSkrot}, od {p.wiek} lat
              </span>
            </button>
          ))}
        </div>

        <button className={styles.startButton} onClick={handleStart} disabled={isLoading}>
          {isLoading ? 'Ładowanie...' : 'Rozpocznij rejs'}
        </button>
      </div>
    </div>
  );
};

export default StartScreen;
